module.exports = function(app) {
	app.directive('autoHeight', autoHeight);
	autoHeight.$inject=[];
	function autoHeight() {
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				scope.$watch(function () {
	                return ngModel.$modelValue;
	            }, function(newValue) {
	            	if(newValue) {
		                function resize () {
	                		element[0].style.overflow = 'hidden';
				            element[0].style.height = 'auto';
				            element[0].style.height = element[0].scrollHeight+'px';
					    }
	                	setTimeout(function() {
				    		resize()
	                	},0) 
	            	}
	            }); 
	        }
	    }
	}	
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/autoHeightDirective.js
// module id = 433
// module chunks = 0